// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"33":"writingAdvise","115":"studentDetail","296":"voluntaryManagement","358":"major","709":"order","917":"refusal","932":"refine-major"}[chunkId] + "." + {"33":"9ca2f46d","115":"9ca2f46d","296":"9ca2f46d","358":"9ca2f46d","709":"9ca2f46d","917":"9ca2f46d","932":"9ca2f46d"}[chunkId] + ".chunk.css";
};